export const unFocusTableRowOnClose = () => {
  const tableFocusedRow = document.querySelector(".MuiDataGrid-row.Mui-selected");
  const tableRowCount = document.querySelector(".MuiDataGrid-selectedRowCount");
  if (tableFocusedRow) tableFocusedRow.classList.remove("Mui-selected");
  if (tableRowCount) tableRowCount.innerHTML = "";
};
